import clsx from "clsx";

import type { ReactNode } from "react";

interface PlanSettingsCardProps {
  backgroundClassName: string;
  left: ReactNode;
  right: ReactNode;
}

export default function PlanSettingsCard({
  backgroundClassName,
  left,
  right,
}: PlanSettingsCardProps) {
  return (
    <section
      className={clsx(
        "w-full grid lg:grid-cols-2 gap-x-2 p-1.5 bg-white bg-cover bg-center rounded-5xl border border-black-200",
        backgroundClassName,
      )}
    >
      {left}
      {right}
    </section>
  );
}
